module.exports = __webpack_public_path__ + "img/17-blog-install-error.f84f61ad.webp";